import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { OpenBankingForm } from "../components/menu/payments/OpenBanking/OpenBankingForm";
import { PaymentCard } from "../components/menu/payments/OpenBanking/PaymentCard";
import { ISidebarItem } from "../components/Routes"
import { useSideTabs } from "../hooks/useSideTabs"
import { IReduxAppState } from "../reducers";
import { AlertStatusCard } from "../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";


interface IProps {
    tab: ISidebarItem;
}

export function OpenBankingContainer({ tab }: IProps) {
    useSideTabs(tab);
    const paymentStage = useSelector((state: IReduxAppState) => state.payments.paymentStage);
    return <div>
        {paymentStage !== 4 && <div style={{
            marginBottom:"1.5rem",
        }}>
            <AlertStatusCard alertProps={{  severity: 'error', style:{
             borderRadius:"8px",
            }}}
            alertMessage={<Trans i18nKey="openBanking.advert.setupPaymentsFirst"
                components={{ bold: <strong /> }} />}
        />
            </div>}
        <PaymentCard />
        <OpenBankingForm />
    </div>
}